import { FC } from "react";

import DashboardLayout from "layouts/DashboardLayout";
import { MFASMSSetup } from "components/MultiFactorAuthorization";
import { MFAWidgetType } from "components/MultiFactorAuthorization/types";
import { NavigationCardWithDetailsAlt } from "components/NavigationCardWithDetails";

import { FullScreenLoader, Loader, Modal } from "uikit";
import { LoaderContainer } from "uikit/Loader/styles";

import useSettingsMFAPage from "./useSettingsMFAPage";
import { OptionsSection } from "./styles";

interface IProps {}

const SettingsMFAPage: FC<IProps> = () => {
  const { metadata, pageData, actions, render } = useSettingsMFAPage();
  const { cardsList } = pageData;
  const { isAddSMSFactorModalOpen, isRemoveSMSFactorModalOpen, isLoading, isDataLoading } =
    metadata;
  const { renderRemoveSMSFactorModalContent } = render;
  const {
    handleAddSMSModalEnterPhoneCancel,
    handleAddSMSModalVerifyCodeCancel,
    handleAddSMSModalSubmitSuccess,
  } = actions;

  return (
    <DashboardLayout>
      {isLoading && <FullScreenLoader />}

      <OptionsSection>
        {isDataLoading ? (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        ) : (
          cardsList.map((option) => {
            return <NavigationCardWithDetailsAlt {...option} key={option.id} />;
          })
        )}
      </OptionsSection>

      {/*NOTE::: Add SMS Factor Modal */}
      <Modal isOpen={isAddSMSFactorModalOpen} showCloseButton={false}>
        <MFASMSSetup
          widgetType={MFAWidgetType.SETTINGS}
          onEnterPhoneCancel={handleAddSMSModalEnterPhoneCancel}
          onVerifyCodeCancel={handleAddSMSModalVerifyCodeCancel}
          onSubmitSuccess={handleAddSMSModalSubmitSuccess}
        />
      </Modal>

      {/*NOTE::: Remove SMS Factor Modal */}
      <Modal isOpen={isRemoveSMSFactorModalOpen} showCloseButton={false}>
        {renderRemoveSMSFactorModalContent()}
      </Modal>
    </DashboardLayout>
  );
};

export default SettingsMFAPage;
